import { HttpStatusCode } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { AlertDisplayType } from "@commonEnums/AlertDisplayType";
import { AlertService } from '@commonServices/alert.service';
import { RequestService } from '@commonServices/request.service';
import { AlertPositionType } from "@enums/alertPositionType";
import { Client as CatalogAPI, CatalogIntegrationCatalogItemViewerDto, CatalogIntegrationCatalogViewerDto, CatalogKeyAndCatalogItemIdsDto } from "@interfaces/HttpClient/CatalogApiPublicModels";
import { firstValueFrom } from "rxjs";

@Injectable()
export class CatalogIntegrationService {

	constructor(private catalogApi: CatalogAPI, private requestService: RequestService, private alertService: AlertService<AlertPositionType>) { }

	private getStatusCodeErrorBasedHandling(e) {
		return [
			{ status: HttpStatusCode.NoContent, return: undefined },
			{
				status: HttpStatusCode.Forbidden, return: () => {
					this.alertService.sendMessage(AlertPositionType.Global, AlertDisplayType.Danger, e.detail)
					return undefined
				}
			}
		]
	}

	async getCatalogIntegrationCatalogViewerSettings(catalogKey: string, integrationKey: string): Promise<CatalogIntegrationCatalogViewerDto> {
		try {
			return await firstValueFrom(this.catalogApi.catalogIntegration_GetCatalogIntegrationCatalogViewerSettings(catalogKey, integrationKey))
		} catch (e) {
			return this.requestService.errorHandling(e, null, this.getStatusCodeErrorBasedHandling(e));
		}
	}

	async getCatalogIntegrationCatalogItemViewerSettings(catalogKey: string, integrationKey: string): Promise<CatalogIntegrationCatalogItemViewerDto> {
		try {
			return await firstValueFrom(this.catalogApi.catalogIntegration_GetCatalogIntegrationCatalogItemViewerSettings(catalogKey, integrationKey))
		} catch (e) {
			return this.requestService.errorHandling(e, null, this.getStatusCodeErrorBasedHandling(e));
		}
	}

	async getSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(catalogItemGuids: string[]): Promise<CatalogKeyAndCatalogItemIdsDto> {
		try {
			return await firstValueFrom(this.catalogApi.catalogIntegration_GetSingleCatalogKeyAndCatalogItemIdsByCatalogItemGuids(catalogItemGuids));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}
}
